export default __webpack_public_path__ + "static/media/icon_weight_Heavy.310b3b6d.png";